import { capitalize, uniqBy } from '@guiker/lodash'

const capitalizeStreetName = (street: string) => {
  return street
    .split(' ')
    .map((segment) => capitalize(segment))
    .join(' ')
}

const uniqueStrings = (strings: string[]) => {
  return uniqBy(strings, (s) => s.toLowerCase())
}

const extractStreetName = (streetName: string, streetNumber: string) => {
  return streetName.replace(streetNumber, '').trim()
}

export { extractStreetName, uniqueStrings, capitalizeStreetName }
